export default __webpack_public_path__ + "static/media/up.d1284303.png";